<p-dialog header="Add Log" [(visible)]="displayAddLog" class="shared-logs" [closable]="false" [modal]="true"
    [style]="{width: '55%'}" appendTo="body">
    <ng-template pTemplate="content">
        <form (ngSubmit)="addLog()" #createLog="ngForm">
            <div class="p-field p-formgrid p-grid">
                <div class="p-col-6">
                    <label>Select Type</label>
                    <p-dropdown placeholder="Choose One" appendTo="body" [options]="logs" [(ngModel)]="selectedLog" placeholder="Select log type"
                    optionLabel="name" required="true" id="logType" name="logType" (onChange)="getSublogType()"
                    [ngClass]="{ 'p-invalid': logType.invalid && (logType.touched || logType.dirty) }"
                    #logType="ngModel" required="true" [filter]="true" filterBy="name" [showClear]="true">
                        <ng-template pTemplate="selectedItem">
                            <div class="p-d-flex" *ngIf="selectedLog">
                                <span class="pi pi-envelope" *ngIf="selectedLog.name == 'Email'" style="margin-top: 0.1rem;"></span>
                                <span class="pi pi-map-marker" *ngIf="selectedLog.name == 'Field Visit'" style="margin-top: 0.1rem;"></span>
                                <span class="fa fa-mobile p-mx-1" *ngIf="selectedLog.name == 'Mobile'" style="font-size: 16px;"></span>
                                <span class="fa fa-pencil-square-o" *ngIf="selectedLog.name == 'Note'" style="font-size: 16px;"></span>
                                <span class="fa fa-phone" *ngIf="selectedLog.name == 'Work'" style="font-size: 16px;"></span>
                                <span class="fa fa-microphone" *ngIf="selectedLog.name == 'Voice Mail'" style="font-size: 16px;"></span>

                                <div class="p-ml-2">{{selectedLog.name}}</div>
                            </div>
                        </ng-template>
                        <ng-template let-log pTemplate="item">
                            <div class="p-d-flex">
                                <span class="pi pi-envelope" *ngIf="log.name == 'Email'"></span>
                                <span class="pi pi-map-marker" *ngIf="log.name == 'Field Visit'"></span>
                                <span class="fa fa-mobile p-mx-1" *ngIf="log.name == 'Mobile'" style="font-size: 16px;margin-top: -2px;"></span>
                                <span class="fa fa-pencil-square-o" *ngIf="log.name == 'Note'" style="font-size: 16px;margin-top: -1px;"></span>
                                <span class="fa fa-phone" *ngIf="log.name == 'Work'" style="font-size: 16px;margin-top: -1px;"></span>
                                <span class="fa fa-microphone" *ngIf="log.name == 'Voice Mail'" style="font-size: 16px;margin-top: -1px;"></span>

                                <div class="p-ml-2">{{log.name}}</div>
                            </div>
                        </ng-template>
                    </p-dropdown>
                    <small class="p-invalid" *ngIf="logType.invalid && (logType.touched || logType.dirty)">Select Log
                        Type</small>
                </div>
                <div class="p-col-6" [ngClass]="{ 'p-d-none': sublogs.length == 0 }">
                    <label>Select Subtype</label>
                    <p-dropdown placeholder="Choose One" appendTo="body" [options]="sublogs" [(ngModel)]="selectedSubLog"
                    placeholder="Select sub log" optionLabel="name" id="subLogType" name="subLogType"
                    [ngClass]="{ 'p-invalid': subLogType.invalid && (subLogType.touched || subLogType.dirty) }"
                    #subLogType="ngModel" [required]="sublogs.length > 0">
                        <ng-template pTemplate="selectedItem">
                            <div class="p-d-flex" *ngIf="selectedSubLog">
                                <img    [src]="assestBaseUrl + 'icons/incoming-call.png'" alt="incomingCall" style="width: 12px;" />
                                <div class="p-ml-2">{{selectedSubLog.name}}</div>
                            </div>
                        </ng-template>
                        <ng-template let-log pTemplate="item">
                            <div class="p-d-flex">
                                <img  [src]="assestBaseUrl + 'icons/outgoing-call.png'" alt="outgoingCall" style="width: 12px;" />
                                <div class="p-ml-2">{{log.name}}</div>
                            </div>
                        </ng-template>
                    </p-dropdown>
                    <small class="p-invalid"
                        *ngIf="subLogType.invalid && (subLogType.touched || subLogType.dirty)">Select Log Type</small>
                </div>
            </div>
            <div class="p-field p-formgrid p-grid">
                <div class="p-col-12">
                    <label class="p-mb-1" for="comment">Comments <span style="color: red;">*</span></label>
                    <quill-editor 
                        placeholder="Enter your comment" [modules]="quillConfig" [(ngModel)]="logTemp.log.commentMessage"
                         (blur)="onBlur(comment)"  #comment="ngModel"  required></quill-editor>
                        <small class="p-invalid" *ngIf="comment.invalid && comment.touched"> Comment is required  </small>
                  </div>
            </div>
            <div class="p-field p-formgrid p-grid">
                <div class="p-col-12">
                    <label>
                        Attachments
                        <i class="pi pi-exclamation-circle" [escape]="false" [pTooltip]="multiLineTooltip"
                            tooltipPosition="top"></i>
                    </label>
                    <p-fileUpload #fileUpload customUpload="true" mode="basic" chooseLabel="Choose"
                        [showUploadButton]="false" [showCancelButton]="false" multiple="multiple"
                        (onSelect)="uploadAttachments($event.files, fileUpload)"></p-fileUpload>
                    <ng-container *ngIf="logTemp.log.logAttachments && (logTemp.log.logAttachments.length > 0)">
                        <app-lion-attachment-chips [attachments]="logTemp.log.logAttachments"
                            (removeAttachment)="removeAttachment($event)"></app-lion-attachment-chips>
                    </ng-container>
                </div>
            </div>
        </form>
    </ng-template>
    <p-footer>
        <button type="button" class="p-button-secondary" pButton (click)="cancel()" label="Cancel"></button>
        <button type="button" pButton label="Save" (click)="createLog.ngSubmit.emit()"></button>
    </p-footer>
</p-dialog>
